<template>
  <div class="repayment-block">
    <p class="repayment-block__date">{{repayData.date | moment('YYYY.MM.DD')}}</p>
    <div class="repayment-block__content">
      <p>
        <span>{{repayData.type === 'LOAN' ? '비상금' : '상환 원금'}}</span>
        <span
          :class="`money-${repayData.type === 'LOAN' ? 'in' : 'out'}`"
        >{{repayData.type === 'LOAN' ? '+' : '-'}}{{repayData.type === 'LOAN' ? repayData.amount : repayData.principal | toCurrency}} 원</span>
      </p>
      <p class="rate" v-if="repayData.interest">
        <span>대출이자</span>
        <span>-{{repayData.interest | toCurrency}} 원</span>
      </p>
      <p class="rate" v-if="repayData.safeplan">
        <span>투자자보호기금</span>
        <span>-{{repayData.safeplan | toCurrency}} 원</span>
      </p>
      <p class="rate" v-if="repayData.fee">
        <span>수수료</span>
        <span :class="`money-${repayData.fee < 0 ? 'in' : ''}`">
          {{0 > repayData.fee ? '+' : '-'}}{{repayData.fee | abs | toCurrency}} 원
        </span>
      </p>
      <p>
        <span>대출 잔액</span>
        <span>{{repayData.loan_balance | toCurrency}} 원</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['repayData']
}
</script>
<style lang="scss" scoped>
.repayment-block {
  &__date {
    color: #8a94a2;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 10px;
    font-weight: 700;
  }

  &__content {
    padding: 20px 25px;
    width: 100%;
    border-radius: 4px;
    background-color: #f7f7f7;

    p {
      display: flex;
      font-size: 16px;
      line-height: 22px;
      font-weight: 900;
      letter-spacing: 0.6px;

      span.money-in {
        color: #1baaf1 !important;
      }
      span.money-out {
        color: #ff1616;
      }

      span:nth-child(1) {
        text-align: left;
        font-weight: 900;
        flex: 1 1 40px;
        color: #333333;
      }
      span:nth-child(2) {
        text-align: right;
        font-weight: 900;
        flex: 2 2 60px;
      }

      &.rate {
        span:nth-child(1) {
          font-size: 14px;
          line-height: 1.57;
          color: #333333;
        }
        span:nth-child(2) {
          font-family: NanumSquareB;
          font-size: 15px;
          font-weight: 500;
          line-height: 1.47;
          color: #727d8c;
        }
      }
    }

    p {
      margin-top: 2px;
      margin-bottom: 2px;
    }

    p:nth-child(2) {
      span:nth-child(2) {
        color: #727d8c;
      }
    }
  }
}
</style>
